function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { classNamesFor } from '../utils/classNames';
/**
 * The Tag component provides a single line text input form element with the
 * option to persist the placeholder label
 *
 * - [MDN docs for input[type="text"]](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/text)
 *
 * ## Related Components
 *
 * - [TextArea](../TextArea/README.md)
 * - [Label](../Label/README.md)
 *
 * ## Usage
 *
 * ```jsx
 * <Tag>PS4</Tag>
 *```
 * ```jsx
 * <Tag>
 *  <Icon type="ps4"" size="xs"/>
 *  <span>PS$</span>
 * </Tag>
 * ```
 *
 * ## Props
 */

var Tag = /*#__PURE__*/function (_PureComponent) {
  _inherits(Tag, _PureComponent);

  var _super = _createSuper(Tag);

  function Tag() {
    _classCallCheck(this, Tag);

    return _super.apply(this, arguments);
  }

  _createClass(Tag, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          qa = _this$props.qa,
          className = _this$props.className,
          children = _this$props.children;

      var _Tag$getClassName = Tag.getClassName({
        className: className
      }),
          root = _Tag$getClassName.root;

      return /*#__PURE__*/React.createElement("span", {
        "data-qa": qa,
        className: root,
        style: {
          heightX: 14
        }
      }, children);
    }
  }]);

  return Tag;
}(PureComponent);

var cx;
Tag.defaultProps = {
  qa: '',
  className: ''
};
Tag.propTypes = {
  /**
   * QA selector attribute used to target important elements for test validation
   */
  qa: PropTypes.string,

  /**
   * Allows adding a custom class or series of classes on the component
   * useful for setting margin or padding
   */
  className: PropTypes.string,

  /**
   * children to be rendered within the tag, typical configurations include
   * text, icon and text or image and text
   */
  children: PropTypes.node.isRequired
};

Tag.getClassName = function (_ref) {
  var className = _ref.className;
  return {
    root: cx('psw-tag', 'psw-l-inline', 'psw-l-line-left', 'psw-bg-black', 'psw-round-s', 'psw-p-x-2xs', 'psw-p-y-3xs', 'psw-body-3', 'psw-text-bold', className)
  };
};

Tag.useClassNames = function (x) {
  Tag.classNames = x;
};

cx = classNamesFor(Tag);
export default Tag;